import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import { useSelector, useDispatch } from 'react-redux'
import { Alert, AlertTitle } from '@material-ui/lab'

import { getPossibleDatesRequest } from 'store/modules/comuns/possibleDates/reducer'
import { findMaxDate, dateNotInDates } from 'services/utils'

import { FormDatePicker } from 'components/CoForm'
import { Box, Typography } from '@material-ui/core'
import { Notifications } from '@material-ui/icons'

export function DatePickerCollect({ type, ...props }) {
  const dispatch = useDispatch()

  const possibleDates = useSelector((state) => state.comuns.possibleDates.dates)

  const collectCount = useSelector((state) => state.users.collections.count)

  const disablePicker = isEmpty(possibleDates)

  const shouldDisableDate = (date) => {
    if (possibleDates.length > 0) return dateNotInDates(date, possibleDates)
    else return false
  }

  useEffect(() => {
    dispatch(getPossibleDatesRequest({ type }))
  }, [dispatch, collectCount, type])

  return (
    <Box pt={1}>
      <FormDatePicker
        disableToolbar
        disablePast
        variant="inline"
        shouldDisableDate={shouldDisableDate}
        maxDate={findMaxDate(possibleDates)}
        disabled={disablePicker}
        {...props}
      />

      <CollectDateAlert />
    </Box>
  )
}

DatePickerCollect.propTypes = {
  type: PropTypes.oneOf(['collect', 'schedule']),
}

DatePickerCollect.defaultProps = {
  type: 'collect',
}

//----------------------------------------------------

export function CollectDateAlert() {
  const possibleDateMessage = useSelector(
    (state) => state.comuns.possibleDates.message
  )

  if (!possibleDateMessage) return null

  return (
    <Box py={1}>
      <Alert severity="warning" variant="standard" icon={<Notifications />}>
        <AlertTitle style={{ fontWeight: 600, fontSize: '1rem' }}>
          Prezado(a) cliente/transportador,
        </AlertTitle>

        <Box mt={2}>
          <Typography
            style={{ fontFamily: '"Roboto", sans-serif' }}
            variant="body1"
            dangerouslySetInnerHTML={{
              __html: possibleDateMessage,
            }}
          />
        </Box>
      </Alert>
    </Box>
  )
}

export default DatePickerCollect
